"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var date_fns_1 = require("date-fns");
var react_redux_1 = require("react-redux");
var SmokeLayer_1 = __importDefault(require("./SmokeLayer"));
var AppConfig_1 = require("../../AppConfig");
var map_1 = require("../../store/reducers/map");
;
var SmokeLayerContainer = function (_a) {
    var mapView = _a.mapView;
    var url = AppConfig_1.MapConfig.SmokeLayerUrl;
    var isVisible = react_redux_1.useSelector(map_1.smokeLayerVisibleSelector);
    var dispatch = react_redux_1.useDispatch();
    var _b = React.useState(), FullTimeExtent = _b[0], setFullTimeExtent = _b[1];
    var _c = React.useState(), activeTimeExtent = _c[0], setActiveTimeExtent = _c[1];
    var _d = React.useState(), timer = _d[0], setTimer = _d[1];
    var TimerSpeed = 2000;
    var getLayerInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestUrl, data, timeInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUrl = url + "/0?f=json";
                    return [4, axios_1.default.get(requestUrl)];
                case 1:
                    data = (_a.sent()).data;
                    timeInfo = data.timeInfo;
                    setFullTimeExtent(timeInfo.timeExtent);
                    return [2];
            }
        });
    }); };
    React.useEffect(function () {
        getLayerInfo();
        return function () {
            clearInterval(timer);
        };
    }, []);
    React.useEffect(function () {
        if (isVisible) {
            var timer_1 = setInterval(function () {
                setActiveTimeExtent(function (activeTimeExtent) {
                    var LayerTimeExtentStart = FullTimeExtent[0], LayerTimeExtentEnd = FullTimeExtent[1];
                    var _a = activeTimeExtent || [undefined, undefined], startTime = _a[0], endTime = _a[1];
                    var newStartTime = startTime ? date_fns_1.add(new Date(startTime), { hours: 1 }).getTime() : LayerTimeExtentStart;
                    if (newStartTime > LayerTimeExtentEnd) {
                        newStartTime = LayerTimeExtentStart;
                    }
                    ;
                    var newEndTime = date_fns_1.add(new Date(newStartTime), { hours: 1 }).getTime();
                    return [
                        newStartTime,
                        newEndTime
                    ];
                });
            }, TimerSpeed);
            setTimer(timer_1);
        }
        else {
            clearInterval(timer);
        }
    }, [isVisible]);
    React.useEffect(function () {
        dispatch(map_1.smokeLayerCurrentTimeExtentChanged(activeTimeExtent));
    }, [activeTimeExtent]);
    return (React.createElement(SmokeLayer_1.default, { url: url, visible: isVisible, timeExtent: activeTimeExtent, mapView: mapView }));
};
exports.default = SmokeLayerContainer;
